<template>
  <v-checkbox v-model="selected" dense hide-details color="blue-grey" class="lean-list-item-checkbox"></v-checkbox>
</template>
<script>
const { mapState, mapMutations } = require('vuex');
export default {
  name: 'lean-list-item-checkbox',
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('SelectedRecordListStore', { selectedRecordList: 'list' }),
    selected: {
      get() {
        return this.selectedRecordList.includes(this.record.slug);
      },
      set(value) {
        if (value) {
          this.addSlugToSelectedRecords(this.record.slug);
        } else {
          this.removeSlugFromSelectedRecords(this.record.slug);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      addSlugToSelectedRecords: 'SelectedRecordListStore/addSlug',
      removeSlugFromSelectedRecords: 'SelectedRecordListStore/removeSlug'
    })
  }
};
</script>
